<template>
  <div id="task">
    <div
      class="container"
      style="max-width: 1600px"
      :class="{ widthBig: screenSize > 1200 }"
    >
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.report") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.reportin") }}</em></small
        >
      </div>
      <div class="space"></div>
      <div class="card">
        <div class="selecter" @click="slide1()">
          <span v-text="selectname1"></span>
          <svg
            t="1702626279362"
            :class="{ down: true, active: active1 }"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4236"
            width="20"
            height="20"
          >
            <path
              d="M512.726547 675.318646c-8.063653 0-15.790638-3.245927-21.435195-9.006118L231.175103 400.906809c-11.603269-11.837606-11.410887-30.840402 0.427742-42.442648 11.837606-11.601222 30.841426-11.410887 42.442648 0.427742l238.681054 243.534596L751.407602 358.891903c11.601222-11.839653 30.602995-12.033058 42.442648-0.427742 11.839653 11.603269 12.031011 30.605042 0.427742 42.442648L534.161742 666.312528C528.517185 672.072719 520.791224 675.318646 512.726547 675.318646z"
              fill="#8a8a8a"
              p-id="4237"
            ></path>
          </svg>
          <div class="list" :style="{ height: firheight + 'px' }">
            <div
              class="listitems"
              v-for="(item, index) in deviceItems"
              :key="index"
              v-text="deviceItems[index].ordernumber"
              @click="select1(index)"
            ></div>
          </div>
        </div>
        <!-- 管 -->
        <a-table
          v-if="selectType1 == 'tube'"
          :dataSource="tableData"
          :columns="columnsTube"
          :loading="taskLoading"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'ProcessType'">
              <a-tag v-if="record.ProcessType == '0'" color="orange">
                {{ $t("file.emptyOperation") }}
              </a-tag>
              <a-tag v-else color="green"> {{ $t("file.process") }} </a-tag>
            </template>
            <template v-if="column.dataIndex === 'IsComplete'">
              <a-tag v-if="record.IsComplete == '0'" color="orange">
                {{ $t("file.notCompleted") }}
              </a-tag>
              <a-tag v-else color="green"> {{ $t("file.completed") }} </a-tag>
            </template>
          </template>
        </a-table>
        <!-- 板 -->
        <a-table
          v-else
          :dataSource="tableData"
          :columns="columns"
          :loading="taskLoading"
        />
      </div>
    </div>

    <div
      class="container"
      style="margin-top: 20px; max-width: 1600px"
      :class="{ widthBig: screenSize > 1200 }"
    >
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.time") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.timein") }}</em></small
        >
      </div>
      <div class="space"></div>
      <div class="card">
        <div class="selecter" @click="slide2()">
          <span v-text="selectname2"></span>
          <svg
            t="1702626279362"
            :class="{ down: true, active: active2 }"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4236"
            width="20"
            height="20"
          >
            <path
              d="M512.726547 675.318646c-8.063653 0-15.790638-3.245927-21.435195-9.006118L231.175103 400.906809c-11.603269-11.837606-11.410887-30.840402 0.427742-42.442648 11.837606-11.601222 30.841426-11.410887 42.442648 0.427742l238.681054 243.534596L751.407602 358.891903c11.601222-11.839653 30.602995-12.033058 42.442648-0.427742 11.839653 11.603269 12.031011 30.605042 0.427742 42.442648L534.161742 666.312528C528.517185 672.072719 520.791224 675.318646 512.726547 675.318646z"
              fill="#8a8a8a"
              p-id="4237"
            ></path>
          </svg>
          <div class="list" :style="{ height: secheight + 'px' }">
            <div
              class="listitems"
              v-for="(item, index) in deviceItems"
              :key="index"
              v-text="deviceItems[index].ordernumber"
              @click="select2(index)"
            ></div>
          </div>
        </div>
        <a-table
          v-if="selectType2 == 'tube'"
          :dataSource="timeData"
          :columns="timeColumnsTube"
          :loading="timeLoading"
        />
        <a-table
          v-else
          :dataSource="timeData"
          :columns="timeColumns"
          :loading="timeLoading"
        />
      </div>
    </div>

    <div
      class="container"
      style="margin-top: 20px; max-width: 1600px"
      :class="{ widthBig: screenSize > 1200 }"
    >
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.statistics") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.statisticsin") }}</em></small
        >
      </div>
      <div class="space"></div>
      <div class="card">
        <div class="card-head">
          <div class="selecter" @click="slide3()" style="margin: 0px">
            <span v-text="selectname3"></span>
            <svg
              t="1702626279362"
              :class="{ down: true, active: active3 }"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4236"
              width="20"
              height="20"
            >
              <path
                d="M512.726547 675.318646c-8.063653 0-15.790638-3.245927-21.435195-9.006118L231.175103 400.906809c-11.603269-11.837606-11.410887-30.840402 0.427742-42.442648 11.837606-11.601222 30.841426-11.410887 42.442648 0.427742l238.681054 243.534596L751.407602 358.891903c11.601222-11.839653 30.602995-12.033058 42.442648-0.427742 11.839653 11.603269 12.031011 30.605042 0.427742 42.442648L534.161742 666.312528C528.517185 672.072719 520.791224 675.318646 512.726547 675.318646z"
                fill="#8a8a8a"
                p-id="4237"
              ></path>
            </svg>
            <div class="list" :style="{ height: thiheight + 'px' }">
              <div
                class="listitems"
                v-for="(item, index) in deviceItems"
                :key="index"
                v-text="deviceItems[index].ordernumber"
                @click="select3(index)"
              ></div>
            </div>
          </div>
          <div class="datebox">
            {{ $t("index.selectWeek") }}：
            <a-range-picker
              :value="hackValue || value"
              :disabled-date="disabledDate"
              @change="onChange"
              @openChange="onOpenChange"
              @calendarChange="onCalendarChange"
              :show-time="{ format: 'YYYY-MM-DD' }"
              format="YYYY-MM-DD"
              :allowClear="false"
            />
          </div>
        </div>
        <div class="flexbox">
          <div class="card taskcount" style="width: 49%">
            <div class="linebox" ref="linebox"></div>
          </div>
          <div class="card taskcount" style="width: 49%">
            <div class="linebox" ref="errorbox"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { onMounted, onUnmounted } from "vue";
import * as echarts from "echarts";
import axios from "axios";
import moment, { Moment } from "moment";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

localStorage.setItem("router", "task");
const screenSize = ref();
const width = window.innerWidth;
screenSize.value = width;
const dates = ref();
const value = ref();
const startTime = ref();
const endTime = ref();
const hackValue = ref();

const table = ref(null);
const active1 = ref(false);
const active2 = ref(false);
const active3 = ref(false);

const orderNumber1 = ref();
const orderNumber2 = ref();
const orderNumber3 = ref();

const taskLoading = ref(false);
const timeLoading = ref(false);

const selectname1 = ref(); //设备号
const selectname2 = ref();
const selectname3 = ref();

const selectType1 = ref();
const selectType2 = ref();
const selectType3 = ref(); //设备类型 tube：管 sheet：板

const typeUrl = ref("api/Machine/GetErrorLogTube"); //默认请求板

let firheight = ref(0);
let secheight = ref(0);
let thiheight = ref(0);

const deviceItems = ref([]);

const columns = ref([
  {
    title: t("index.reporttb1"),
    dataIndex: "TaskName",
  },
  {
    title: t("index.reporttb2"),
    dataIndex: "CuttingLength",
  },
  {
    title: t("index.reporttb7"),
    dataIndex: "PunchingNum",
  },
  {
    title: t("index.reporttb8"),
    dataIndex: "ProcessingTime",
  },
  {
    title: t("index.reporttb3"),
    dataIndex: "EmptyLength",
  },
  {
    title: t("index.reporttb4"),
    dataIndex: "StartTime",
  },
  {
    title: t("index.reporttb5"),
    dataIndex: "EndTime",
  },
  {
    title: t("index.reporttb6"),
    dataIndex: "FileUrl",
    width: "200px",
  },
]);

const columnsTube = ref([
  {
    title: t("file.slicingLength"),
    dataIndex: "SlicingLength",
  },
  {
    title: t("file.slicingDuration"),
    dataIndex: "SlicingDuration",
  },
  {
    title: t("index.reporttb7"),
    dataIndex: "PierceCount",
  },
  {
    title: t("file.pierceDuration"),
    dataIndex: "PierceDuration",
  },
  {
    title: t("file.totalDuration"),
    dataIndex: "TotalDuration",
  },
  {
    title: t("file.idleLength"),
    dataIndex: "IdleLength",
  },
  {
    title: t("file.partCount"),
    dataIndex: "PartCount",
  },
  {
    title: t("file.thickness"),
    dataIndex: "Thickness",
  },
  {
    title: t("file.useTubeCount"),
    dataIndex: "UseTubeCount",
  },
  {
    title: t("index.reporttb4"),
    dataIndex: "StartTime",
  },
  {
    title: t("index.reporttb5"),
    dataIndex: "EndTime",
  },
  {
    title: t("file.processType"),
    dataIndex: "ProcessType",
  },
  {
    title: t("file.isComplete"),
    dataIndex: "IsComplete",
  },
]);

const timeColumns = ref([
  {
    title: t("index.timetb1"),
    dataIndex: "Run",
  },
  {
    title: t("index.timetb2"),
    dataIndex: "Idle",
  },
  {
    title: t("index.timetb3"),
    dataIndex: "Offline",
  },
  {
    title: t("index.timetb4"),
    dataIndex: "CreateTime",
  },
]);

const timeColumnsTube = ref([
  {
    title: t("index.timetb1"),
    dataIndex: "Run",
  },
  {
    title: t("index.timetb2"),
    dataIndex: "Idle",
  },
  {
    title: t("index.timetb3"),
    dataIndex: "Offline",
  },
  {
    title: t("index.timetb5"),
    dataIndex: "Estop",
  },
  {
    title: t("index.timetb4"),
    dataIndex: "CreateTime",
  },
]);

let tableData = ref([]);
let timeData = ref([]);

function getDates() {
  // 获取当前日期
  let currentDate = new Date();

  // 获取七天前的日期
  let sevenDaysAgo = new Date(currentDate.getTime() - 6 * 24 * 60 * 60 * 1000);

  // 将日期对象转换为ISO 8601格式的字符串
  let sevenDaysAgoString = sevenDaysAgo.toISOString().split("T")[0];
  let currentDateString = currentDate.toISOString().split("T")[0];

  // 返回一个包含两个日期的数组
  return [sevenDaysAgoString, currentDateString];
}

let defautTime = getDates();
startTime.value = defautTime[0];
endTime.value = defautTime[1];

function getDatesBetween(startDateStr, endDateStr) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  let dates = [];
  let currentDate = startDate;

  while (currentDate <= endDate) {
    let dateStr = currentDate.toLocaleDateString("default", {
      month: "2-digit",
      day: "2-digit",
    });
    dates.push(dateStr);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  dates = dates.map((date) => date.split("/").join("-"));
  return dates;
}

function countObjectsByDate(a, b) {
  // 初始化一个与数组a长度相同的数组，用于存储每个日期的对象数量
  const countArray = new Array(a.length).fill(0);
  // 遍历数组b中的每个对象
  b.forEach((obj) => {
    let createTimeDate;
    if (obj.CreateTime) {
      createTimeDate = obj.CreateTime.split(" ")[0]; // 提取CreateTime字段的日期部分
    } else if (obj.ErrorDate) {
      createTimeDate = obj.ErrorDate.split(" ")[0]; // 提取ErrorDate字段的日期部分
    } else {
      createTimeDate = obj.StartTime.split(" ")[0]; //提取StartTime字段的日期部分
    }
    createTimeDate = createTimeDate.split("-")[1] + "-" + createTimeDate.split("-")[2];
    // 检查这个日期是否在数组a的格式化日期列表中
    const index = a.indexOf(createTimeDate);

    // 如果找到匹配的日期，则对应位置的计数器加1
    if (index !== -1) {
      countArray[index] += 1;
    }
  });

  return countArray;
}

function getWorkData(startTime, endTime, orderNumber) {
  axios
    .post("api/Machine/GetMachineTasks", {
      OrderNumber: orderNumber,
      CreateTimeS: startTime,
      CreateTimeE: endTime,
    })
    .then((response) => {
      if (response.data.code != 200 && response.data.info != "数据查询为空！") {
        message.error(response.data.info);
      } else {
        if (response.data.ReturnData.length >= 1) {
          weekData.value.hourData = countObjectsByDate(
            getDatesBetween(startTime, endTime),
            response.data.ReturnData
          );
        } else {
          weekData.value.hourData = new Array(weekData.value.time.length).fill(0);
        }
        initChart();
      }
    })
    .catch((error) => {
      console.error(error);
    });
}
//请求报警数据
function getErrorData(startTime, endTime, orderNumber) {
  axios
    .post(typeUrl.value, {
      OrderNumber: orderNumber,
      ErrorDateS: startTime,
      ErrorDateE: endTime,
    })
    .then((response) => {
      if (response.data.code != 200 && response.data.info != "数据查询为空！") {
        message.error(response.data.info);
      } else {
        if (response.data.ReturnData.length >= 1) {
          errorDat.value.hourData = countObjectsByDate(
            getDatesBetween(startTime, endTime),
            response.data.ReturnData
          );
        } else {
          errorDat.value.hourData = new Array(errorDat.value.time.length).fill(0);
        }
        initErrorChart();
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

const disabledDate = (current) => {
  if (!dates.value || dates.value.length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], "days") > 6;
  const tooEarly = dates.value[1] && dates.value[1].diff(current, "days") > 6;
  return tooEarly || tooLate;
};
const onOpenChange = (open) => {
  if (open) {
    dates.value = [];
    hackValue.value = [];
  } else {
    hackValue.value = undefined;
  }
};
const onChange = (val, dateString) => {
  value.value = val;
  if (dateString.length) {
    startTime.value = dateString[0];
    endTime.value = dateString[1];
  }
  weekData.value.time = getDatesBetween(startTime.value, endTime.value);
  errorDat.value.time = getDatesBetween(startTime.value, endTime.value);
  getWorkData(startTime.value, endTime.value, orderNumber3.value);
  getErrorData(startTime.value, endTime.value, orderNumber3.value);
};

const onCalendarChange = (val) => {
  dates.value = val;
};

const slide1 = () => {
  active1.value = !active1.value;
  firheight.value = 0;
  if (active1.value) {
    let num = deviceItems.value.length;
    firheight.value = num * 30;
  }
};
//第一个设备选择框
const select1 = (index) => {
  selectname1.value = deviceItems.value[index].ordernumber; //设备号
  selectType1.value = deviceItems.value[index].type; //设备类型 tube：管 sheet：板
  getTable(deviceItems.value[index].ordernumber, deviceItems.value[index].type);
  orderNumber1.value = deviceItems.value[index].ordernumber;
  firheight.value = 0;
};

const slide2 = () => {
  active2.value = !active2.value;
  secheight.value = 0;
  if (active2.value) {
    let num = deviceItems.value.length;
    secheight.value = num * 30;
  }
};

const select2 = (index) => {
  selectname2.value = deviceItems.value[index].ordernumber; //设备号
  selectType2.value = deviceItems.value[index].type;
  getTime(deviceItems.value[index].ordernumber, deviceItems.value[index].type);
  orderNumber2.value = deviceItems.value[index].ordernumber;
  secheight.value = 0;
};

const slide3 = () => {
  active3.value = !active3.value;
  thiheight.value = 0;
  if (active3.value) {
    let num = deviceItems.value.length;
    thiheight.value = num * 30;
  }
};

const select3 = (index) => {
  selectname3.value = deviceItems.value[index].ordernumber; //设备号
  selectType3.value = deviceItems.value[index].type; //设备类型 tube：管 sheet：板
  if (selectType3.value == "tube") {
    //管
    typeUrl.value = "api/Machine/GetErrorLogTube";
  } else {
    //板
    typeUrl.value = "api/Machine/GetErrorLog";
  }
  orderNumber3.value = deviceItems.value[index].ordernumber;
  weekData.value.time = getDatesBetween(startTime.value, endTime.value);
  errorDat.value.time = getDatesBetween(startTime.value, endTime.value);
  getWorkData(startTime.value, endTime.value, orderNumber3.value);
  getErrorData(startTime.value, endTime.value, orderNumber3.value);
  thiheight.value = 0;
};

const user = ref();
user.value = JSON.parse(localStorage.getItem("user"));

axios
  .post("api/Machine/GetMyMachine", {
    UserId: user.value.UserId,
  })
  .then((response) => {
    if (response.data.code != 200 && response.data.info != "数据查询为空！") {
      message.error(response.data.info);
    } else {
      if (Array.isArray(response.data.ReturnData)) {
        response.data.ReturnData.map((data, index) => {
          deviceItems.value[index] = {
            equipmentid: data.equipmentid,
            name: data.name,
            infoStatus: data.communicationstatus,
            ordernumber: data.ordernumber,
            type:
              data.seriesname == "M系列" ||
              data.seriesname == "T系列" ||
              data.seriesname == "K系列" ||
              data.seriesname == "Q系列"
                ? "tube"
                : "sheet",
          };
        });
        selectname1.value = deviceItems.value[0].ordernumber; //设备号
        selectname2.value = deviceItems.value[0].ordernumber;
        selectname3.value = deviceItems.value[0].ordernumber;
        orderNumber1.value = deviceItems.value[0].ordernumber;
        orderNumber2.value = deviceItems.value[0].ordernumber;
        orderNumber3.value = deviceItems.value[0].ordernumber;
        selectType1.value = deviceItems.value[0].type;
        selectType2.value = deviceItems.value[0].type;
        selectType3.value = deviceItems.value[0].type;
      }
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    if (deviceItems.value.length >= 1) {
      getTable(deviceItems.value[0].ordernumber, deviceItems.value[0].type);
      getTime(deviceItems.value[0].ordernumber);
      weekData.value.time = getDatesBetween(startTime.value, endTime.value);
      errorDat.value.time = getDatesBetween(startTime.value, endTime.value);
      getWorkData(defautTime[0], defautTime[1], orderNumber3.value);
      getErrorData(defautTime[0], defautTime[1], orderNumber3.value);
    }
  });

function getTable(ordernumber, type) {
  //设备号，设备类型
  taskLoading.value = true;
  if (type == "tube") {
    //管
    axios
      .post("api/Machine/GetReportTube", {
        OrderNumber: ordernumber,
      })
      .then((response) => {
        if (response.data.code != 200 && response.data.info != "数据查询为空！") {
          message.error(response.data.info);
        } else {
          if (tableData.value) tableData.value = response.data.ReturnData;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        taskLoading.value = false;
      });
  } else {
    //板
    axios
      .post("api/Machine/GetMachineReport", {
        OrderNumber: ordernumber,
      })
      .then((response) => {
        if (response.data.code != 200 && response.data.info != "数据查询为空！") {
          message.error(response.data.info);
        } else {
          if (tableData.value) tableData.value = response.data.ReturnData;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        taskLoading.value = false;
      });
  }
}

function getTime(ordernumber, type) {
  timeLoading.value = true;
  if (type == "tube") {
    axios
      .post("api/Machine/GetProcessingTimeTube", {
        OrderNumber: ordernumber,
      })
      .then((response) => {
        if (response.data.code != 200 && response.data.info != "数据查询为空！") {
          message.error(response.data.info);
        } else {
          if (timeData.value) timeData.value = response.data.ReturnData;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        timeLoading.value = false;
      });
  } else {
    axios
      .post("api/Machine/GetProcessingTimes", {
        OrderNumber: ordernumber,
      })
      .then((response) => {
        if (response.data.code != 200 && response.data.info != "数据查询为空！") {
          message.error(response.data.info);
        } else {
          if (timeData.value) timeData.value = response.data.ReturnData;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        timeLoading.value = false;
      });
  }
}

const loadOut = (id) => {
  alert(id + ":导出成功!");
};

const weekData = ref({
  time: ["2.18", "2.19", "2.20", "2.21", "2.22", "2.23", "2.24"],
  hourData: [0, 0, 0, 0, 0, 0, 0],
});

const errorDat = ref({
  time: ["2.18", "2.19", "2.20", "2.21", "2.22", "2.23", "2.24"],
  hourData: [0, 0, 0, 0, 0, 0, 0],
});

let linebox = ref(null);
let errorbox = ref(null);

let myEcharts = echarts;

onMounted(() => {
  initChart();
  initErrorChart();
});

onUnmounted(() => {
  myEcharts.dispose;
});

function initChart() {
  let chart = myEcharts.init(linebox.value, null, {
    renderer: "svg",
  });
  let option;

  option = {
    color: "rgba(84, 112, 198, 1)",
    title: {
      text: t("index.statisticsChart1"),
      left: 0,
      top: 0,
      textStyle: {
        fontSize: 16,
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: weekData.value.time,
    },
    grid: {
      top: "15%",
      left: "3%",
      right: "5%",
      bottom: "0%",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985",
        },
      },
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: weekData.value.hourData,
        type: "line",
        name: "加工任务数",
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(84, 112, 198, 1)", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(84, 112, 198, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        },
      },
    ],
  };
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  };
}

function initErrorChart() {
  let chart = myEcharts.init(errorbox.value, null, {
    renderer: "svg",
  });
  let option;

  option = {
    color: "rgba(250, 200, 88, 1)",
    title: {
      text: t("index.statisticsChart2"),
      left: 0,
      top: 0,
      textStyle: {
        fontSize: 16,
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: errorDat.value.time,
    },
    grid: {
      top: "15%",
      left: "3%",
      right: "5%",
      bottom: "0%",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985",
        },
      },
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: errorDat.value.hourData,
        type: "line",
        name: "告警数",
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(250, 200, 88, 1)", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(250, 200, 88, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        },
      },
    ],
  };
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  };
}
</script>

<style scoped>
#task {
  padding: 100px 0px;
  background-color: #f7f9fa;
}

.zeropadding {
  padding: 0px;
}

.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  padding: 30px;
  background-color: white;
}

.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 0px 10px;
}

table {
  width: 100%;
}

.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}

a {
  cursor: pointer;
  color: #1890ff;
}

th {
  color: #fff;
  background-color: #555;
  border: 1px solid #555;
  font-size: 14px;
  padding: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  vertical-align: top;
  text-align: left;
}

tr:nth-child(even) {
  background-color: #fff;
}

tr:nth-child(odd) {
  background-color: #f6f4f0;
}

td {
  line-height: 2em;
  min-width: 24px;
  border: 1px solid #d4d4d4;
  padding: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  vertical-align: top;
}

.flexbox {
  display: flex;
  justify-content: space-between;
}

.linebox {
  width: 100%;
  height: 300px;
}

.taskcount {
  padding: 15px;
}

.selecter {
  width: 200px;
  height: 30px;
  box-shadow: 0 0 0 1px #c0c4cc inset;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 11px;
  background-color: white;
  background-image: none;
  border-radius: 4px;
  margin-bottom: 20px;
  position: relative;
}

.list {
  height: 0px;
  width: 200px;
  position: absolute;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 10px -2px #0000001f;
  transition: all 0.3s;
  top: 40px;
  left: 0px;
  z-index: 99;
  background-color: white;
  border-radius: 4px;
}

.listitems {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: black;
  cursor: pointer;
}

.listitems:hover {
  background-color: #eeeeee;
}

.down {
  transform: rotate(0deg);
  transition: all 0.3s;
}

.active {
  transform: rotate(-180deg);
}

.datebox {
  height: 100%;
  display: flex;
  align-items: center;
}

.datepicker {
  width: 200px;
  height: 30px;
  cursor: pointer;
  background-color: white;
  background-image: none;
  border-radius: 4px;
  position: relative;
}
.widthBig {
  width: 1600px;
}
</style>
